import { render, staticRenderFns } from "./Gridbox.vue?vue&type=template&id=2193c992&scoped=true&"
import script from "./Gridbox.vue?vue&type=script&lang=ts&"
export * from "./Gridbox.vue?vue&type=script&lang=ts&"
import style0 from "./Gridbox.vue?vue&type=style&index=0&id=2193c992&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2193c992",
  null
  
)

export default component.exports